import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FluidImg from 'Components/Utility/FluidImg';
import Meta from 'Components/Utility/SEO/Meta';
import GameBundleSection from 'Containers/AlgoliaSections/GameBundleSection';

const PickAndMixProductPage = ({ pickAndMix }) => {
  const {
    slug,
    name,
    description: shortDesc,
    cover_image: cover,
  } = pickAndMix;

  return (
    <main className="PickAndMixProductPage">
      <Meta
        title={`${name} | Fanatical`}
        url={`pick-and-mix/${slug}`}
        description={shortDesc}
        image={`product/1280x720/${cover}`}
        pageType="ItemPage"
      />
      <div className="PickAndMixProductPage__backgroundContrast">
        <div className="PickAndMixProductPage__backgroundContrastSlash"/>
      </div>
      <div className="PickAndMixProductPage__content container">
        <section className="PickAndMixProductPage__content__left">
          <h1 className="PickAndMixProductPage__content__title">
            <FormattedMessage
              id="PickAndMixNoProducts.regionLocked.title"
              defaultMessage="Sorry, The {name} is not available in your region"
              values={{
                name,
              }}
            />
          </h1>
          <p className="PickAndMixProductPage__content__shortDesc">
            <FormattedMessage
              id="PickAndMixNoProducts.regionLocked.other"
              defaultMessage="Here are some of our other great bundles that are available for you."
            />
          </p>
          <GameBundleSection slugToRemove={slug} />

        </section>
        <aside className="PickAndMixProductPage__content__right">
          <div className="PickAndMixProductPage__stickyContainer">
            <div className="PickAndMixProductPage__content__cover responsive-image responsive-image--16by9">
              <FluidImg
                className="img-force-full"
                src={cover}
                alt={name}
                lazy={false}
                sizesOverride="(min-width: 576px) 524px, calc(100vw - 1rem)"
              />
            </div>
          </div>
        </aside>
      </div>
    </main>
  );
};

PickAndMixProductPage.propTypes = {
  pickAndMix: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    cover_image: PropTypes.string,
    slug: PropTypes.string,
  }),
};

PickAndMixProductPage.defaultProps = {
  pickAndMix: null,
};

export default PickAndMixProductPage;
